import React from "react";
import PropertyWidget from "../propertyWidget/property";
const NewGridWidget = () => {
    return (<PropertyWidget loadAmenities={false} isGrid={true} defaultCount={6} />)
}

export default NewGridWidget;